import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import Axios from "axios";
import titleMixin from '@/components/meta/titleMixin';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import i18n from '@/plugins/i18n';

Vue.mixin(titleMixin)

Vue.config.productionTip = false;
Vue.prototype.$http = Axios;

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount("#app");
